<div class="deploys-frequency-details">
  <div class="details-header">
    <h4 class="details-title">Deploys en producción del mes</h4>
    @if (worstGapDaysCount() !== null) {
      <div class="details-summary">
        <span class="summary-pill">{{ deploysCount() }} deploy{{ deploysCount() === 1 ? '' : 's' }}</span>
        <span class="summary-pill"
          >{{ intervalsCount() }} intervalo{{ intervalsCount() === 1 ? '' : 's' }} evaluado{{ intervalsCount() === 1 ? '' : 's' }}</span
        >
      </div>
    }
  </div>

  @if (worstGapDaysCount() === null) {
    <p class="no-data">No hay datos disponibles</p>
  } @else {
    <div class="average-days">
      <div class="average-item">
        <span class="average-label">Peor intervalo entre deploys</span>
        <span class="average-value">{{ worstGapDaysCount() }} días</span>
      </div>
    </div>
  }
</div>
